'use client'

import { FormField } from '@/components/form-section'
import { cancelSalesTask, completeSalesTask } from '@/lib/api/sales/tasks-api'
import { useState } from 'react'
import { toast } from 'react-toastify'

export type SalesTaskFinishAction = 'complete' | 'cancel'

/** Concluir (com resultado) ou cancelar (com motivo) uma tarefa. Usado no lead e na agenda. */
export default function SalesTaskFinishModal({
    task,
    action,
    onClose,
}: {
    task: { id: number; title: string }
    action: SalesTaskFinishAction
    onClose: (finished: boolean) => void
}) {
    const [result, setResult] = useState('')
    const [saving, setSaving] = useState(false)
    const completing = action === 'complete'

    const handleFinish = async () => {
        setSaving(true)
        try {
            const res = completing
                ? await completeSalesTask(task.id, result.trim() || undefined)
                : await cancelSalesTask(task.id, result.trim() || undefined)
            if (res.success) {
                toast.success(completing ? 'Tarefa concluída' : 'Tarefa cancelada')
                onClose(true)
            } else {
                toast.error(res.error || 'Não foi possível atualizar a tarefa')
            }
        } catch {
            toast.error('Não foi possível atualizar a tarefa')
        } finally {
            setSaving(false)
        }
    }

    return (
        <div className="modal modal-open">
            <div className="modal-box max-w-md">
                <h3 className="mb-1 text-lg font-bold">{completing ? 'Concluir tarefa' : 'Cancelar tarefa'}</h3>
                <p className="mb-4 text-sm text-base-content/60">{task.title}</p>
                <FormField label={completing ? 'Resultado' : 'Motivo'} htmlFor="task-result" optional>
                    <textarea
                        id="task-result"
                        className="textarea textarea-bordered w-full text-sm"
                        rows={3}
                        placeholder={completing ? 'Ex.: Cliente confirmou para amanhã' : 'Ex.: Cliente pediu para não ligar'}
                        value={result}
                        onChange={e => setResult(e.target.value)}
                    />
                </FormField>
                <div className="modal-action">
                    <button type="button" className="btn btn-ghost btn-sm" onClick={() => onClose(false)} disabled={saving}>
                        Voltar
                    </button>
                    <button type="button" className={`btn btn-sm ${completing ? 'btn-success' : 'btn-error'}`} onClick={handleFinish} disabled={saving}>
                        {saving ? <span className="loading loading-spinner loading-xs" /> : completing ? 'Concluir' : 'Cancelar tarefa'}
                    </button>
                </div>
            </div>
            <div className="modal-backdrop" onClick={() => !saving && onClose(false)} />
        </div>
    )
}
